.root {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
}

.messages {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);
}

.jumpToLatest {
  position: absolute;
  bottom: var(--dixa-size-spacer-300);
  left: 50%;
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, var(--dixa-size-spacer-200));
  transition:
    opacity 120ms ease-in,
    transform 120ms ease-in,
    visibility 0s linear 120ms;
}

.visible {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
  transition:
    opacity 150ms ease-out,
    transform 150ms ease-out,
    visibility 0s;
}

@media (prefers-reduced-motion: reduce) {
  .jumpToLatest,
  .visible {
    transform: translate(-50%, 0);
  }
}
